import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { firstValueFrom, Observable } from 'rxjs';

import { AuthApi } from '../api/auth.api';
import { IChangePasswordRequest } from '../interfaces/auth/auth.interface';

import { UnsavedChangesService } from './unsaved-changes.service';
import { UserService } from './user.service';

/** Вход и выход (CRM-122). Сессия — cookie API, клиент токенов не видит. */
@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly _api = inject(AuthApi);
  private readonly _user = inject(UserService);
  private readonly _router = inject(Router);
  private readonly _unsaved = inject(UnsavedChangesService);

  public login(login: string, password: string): Observable<void> {
    return this._api.login(login, password);
  }

  public changePassword(request: IChangePasswordRequest): Observable<void> {
    return this._api.changePassword(request);
  }

  /**
   * Сначала вопрос о несохранённых правках: после сброса пользователя «Остаться» оставило бы экран без сессии.
   * Пользователь сбрасывается до запроса: `401` мёртвой сессии не станет «Сессия закончилась». Ошибка — всё равно на вход.
   */
  public async logout(): Promise<void> {
    if (!(await this._unsaved.confirmLeave())) return;
    this._unsaved.setDirty(false);
    this._user.clear();
    await firstValueFrom(this._api.logout()).catch(() => undefined);
    // Переход может отменить guard (идёт создание должника из ПАУ) — тогда перезагрузка: экран без сессии не оставляем.
    if (!(await this._router.navigate(['/login']))) location.assign('/login');
  }

  /**
   * Единственная точка «сессия закончилась» (S10). Сохранить уже нельзя — вопрос о правках не задаём.
   * Сброс пользователя отсекает параллельные `401`: они придут уже без него.
   */
  public expired(): void {
    if (!this._user.userInfo$$()) return;
    this._unsaved.setDirty(false);
    this._user.clear();
    void this._router.navigate(['/login'], { queryParams: { returnUrl: this._router.url, expired: 1 } });
  }
}
